(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/objectWithoutProperties", "../../constants", "../../request", "./events.schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/objectWithoutProperties"), require("../../constants"), require("../../request"), require("./events.schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.objectWithoutProperties, global.constants, global.request, global.events);
    global.events = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _objectWithoutProperties2, _constants, _request, _events) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackEmbeddedSession = _exports.trackEmbeddedReceived = _exports.trackEmbeddedDismiss = _exports.trackEmbeddedClick = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  var _excluded = ["appPackageName"],
    _excluded2 = ["appPackageName"],
    _excluded3 = ["appPackageName"];
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var trackEmbeddedReceived = _exports.trackEmbeddedReceived = function trackEmbeddedReceived(messageId, appPackageName) {
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_received_event_track.route,
      data: {
        messageId: messageId,
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: global.navigator.userAgent || '',
          appPackageName: appPackageName
        }
      },
      validation: {
        data: _events.trackEmbeddedSchema
      }
    });
  };
  var trackEmbeddedClick = _exports.trackEmbeddedClick = function trackEmbeddedClick(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_click_event_track.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: global.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.trackEmbeddedClickSchema
      }
    });
  };
  var trackEmbeddedDismiss = _exports.trackEmbeddedDismiss = function trackEmbeddedDismiss(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded2);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_dismiss.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: global.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.embeddedDismissSchema
      }
    });
  };
  var trackEmbeddedSession = _exports.trackEmbeddedSession = function trackEmbeddedSession(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded3);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_session_event_track.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: global.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.embeddedSessionSchema
      }
    });
  };
});